export default {
  "common.brand": "US Fans Spreadsheet",
  "common.tagline": "Recurso independiente de merch para fans",
  "common.buyNow": "Comprar ahora",
  "common.visitStore": "Visitar tienda",
  "common.guide": "Guía",
  "common.home": "Inicio",
  "common.shoppingGuide": "Guía de compra",
  "common.menu": "Menú",
  "common.selectCategory": "Elige una categoría…",
  "common.browseCategories": "Ver categorías",
  "common.readMore": "Leer más",
  "common.external": "Se abre en una pestaña nueva",
  "common.backHome": "Volver al inicio",
  "lang.en": "English",
  "lang.es": "Español",
  "lang.fr": "Français",
  "lang.pl": "Polski",
  "footer.tagline": "Un centro independiente que organiza el merch para fans en categorías fáciles de explorar.",
  "footer.resources": "Recursos",
  "footer.categories": "Categorías",
  "footer.guide": "Guía de merch para fans",
  "footer.visitStore": "Visitar la tienda principal",
  "footer.disclaimer": "US Fans Spreadsheet es un recurso informativo independiente y no está afiliado ni respaldado por ninguna marca o equipo oficial.",
  "footer.rights": "Todos los derechos reservados.",
};